module.exports = __webpack_public_path__ + "media/bootstrap-icons/brightness-high-fill-172520ce.svg";